import React, { useCallback, useState } from 'react';
import { Button, Grid, Modal, Input } from 'semantic-ui-react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { closeCreateFolderModal, getTemplateFolders } from '../../../actions/folders';
import API from '../../../utils/API';
import errorHandler from '../../../utils/errorHandler';
import { toastSuccess } from '../../../utils/toastMessage';

function ModalCreateFolder({ onCreateFolderModal, closeCreateFolderModal, getTemplateFolders }) {
  const [isLoadingCreate, setIsLoadingCreate] = useState(false);
  const [name, setName] = useState('');
  const [isError, setIsError] = useState(false);
  const [isCreateError, setCreateError] = useState(false);

  const onChangeName = useCallback((e) => {
    if (isError) setIsError(false);
    if (isCreateError) setCreateError(false);
    setName(e.target.value);
  });

  const createNewFolder = useCallback(() => {
    const trimmedCurrentFolderName = name.trim();
    if (
      trimmedCurrentFolderName === '' ||
      trimmedCurrentFolderName.length < 2 ||
      trimmedCurrentFolderName.length > 50
    ) {
      setIsError(true);
      setCreateError(true);
      return;
    }
    setIsLoadingCreate(true);
    if (isCreateError) setCreateError(false);
    API.post(`/templateFolder/`, {
      title: name,
    })
      .then(() => {
        setIsLoadingCreate(false);
        toastSuccess('Папка успешно создана');
        getTemplateFolders();
        closeCreateFolderModal();
      })
      .catch(function (error) {
        const errorConfig = {
          404: {
            message: 'Шаблонов не найдено',
          },
          400: {
            message: 'Папка с таким названием уже существует',
          },
        };
        if (error.response) {
          setIsLoadingCreate(false);
          setCreateError(true);
          errorHandler(error.response.status, errorConfig);
        }
      });
  });

  const onKeyPressHandler = (event) => {
    if (event.key === 'Enter') {
      createNewFolder();
    }
  };

  return (
    <Grid>
      <Grid.Column width={4}>
        <Modal open={onCreateFolderModal} closeIcon onClose={closeCreateFolderModal}>
          <Modal.Header style={{ textAlign: 'center' }}>Создайте новую папку</Modal.Header>
          <Container>
            <Label>Введите название папки</Label>
            <Input
              placeholder="Название папки"
              value={name}
              onChange={onChangeName}
              error={isCreateError}
              onKeyPress={onKeyPressHandler}
            />
            {isError && (
              <ErrorText>Название папки должно содержать от 2х до 50ти символов</ErrorText>
            )}
          </Container>
          <Modal.Actions>
            <Button loading={isLoadingCreate} onClick={createNewFolder} positive>
              Создать
            </Button>
          </Modal.Actions>
        </Modal>
      </Grid.Column>
    </Grid>
  );
}

const mapStateToProps = (state) => {
  const { onCreateFolderModal } = state.folders;
  return {
    onCreateFolderModal,
  };
};

const mapDispatchToProps = (dispatch) => ({
  closeCreateFolderModal: () => dispatch(closeCreateFolderModal()),
  getTemplateFolders: () => dispatch(getTemplateFolders()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ModalCreateFolder);

const Label = styled.label`
  width: 100%;
  font-size: 24px;
  cursor: pointer;
  margin-bottom: 15px;
`;
const Container = styled.div`
  margin: 25px;
  display: flex;
  flex-direction: column;
`;

const ErrorText = styled.div`
  color: red;
  margin: 5px;
  font-size: 10px;
`;



// WEBPACK FOOTER //
// ./src/Components/TemplateGenerator/FoldersModals/ModalCreateFolder.js